import { render, staticRenderFns } from "./RegistrationNewUserComponent.vue?vue&type=template&id=ae08228a&scoped=true"
import script from "./RegistrationNewUserComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationNewUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae08228a",
  null
  
)

export default component.exports